import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import MainLayout from "../../layouts/main/main_layout";
import ChoicesLayout from "../../layouts/choices/choices_layout";
import useUser from "../../providers/user/user_provider";

import ChoicesListing from "./components/choices_listing_page/choices_listing";
import AutoNotificationCreatedEvent from "./components/choices-auto-notification/auto_notification_event_created";

import AccessDenied from "../../components/access_denied/access_denied";

export default function Choices() {
  const { hasPermission } = useUser();

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const tabFromUrl = Number(searchParams.get("tab"));

  const [currentTab, setCurrentTab] = useState<number>(
    !isNaN(tabFromUrl) ? tabFromUrl : 0
  );

  useEffect(() => {
    if (!isNaN(tabFromUrl) && tabFromUrl !== currentTab) {
      setCurrentTab(tabFromUrl);
    }
  }, [tabFromUrl]);

  const handleChange = (newValue: number) => {
    setCurrentTab(newValue);

    // Preserve existing params
    const params = new URLSearchParams(searchParams);

    params.set("tab", String(newValue));

    navigate({
      search: params.toString(),
    });
  };

  return (
    <MainLayout>
      {hasPermission("choices", "read") ? (
        <ChoicesLayout currentTab={currentTab} onTabChange={handleChange}>
          {currentTab === 0 ? (
            <ChoicesListing />
          ) : (
            <AutoNotificationCreatedEvent />
          )}
        </ChoicesLayout>
      ) : (
        <Box
          display="flex"
          flex={1}
          width="100%"
          height="100%"
        >
          <AccessDenied />
        </Box>
      )}
    </MainLayout>
  );
}